/* This function takes a link and a value to find in that link, when it finds the value it returns the substring
  after that value i.e.  getShortKey("http//perkbox.net/teams/devs", "teams/") will return "devs"
*/
var getShortKey = function (link, find) {
    return link.substring(link.indexOf(find) + find.length);
};
export default getShortKey;
